// Client-side form validation utilities

export function validateEmail(email: string): string | null {
  if (!email.trim()) return 'Email is required'
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) return 'Please enter a valid email address'
  return null
}

export function validateRequired(value: string, fieldName: string): string | null {
  if (!value.trim()) return `${fieldName} is required`
  return null
}

export function validateOrgName(name: string): string | null {
  if (!name.trim()) return 'Organisation name is required'
  if (name.trim().length < 2) return 'Organisation name must be at least 2 characters'
  if (name.trim().length > 255) return 'Organisation name must be 255 characters or less'
  return null
}

export function validateUrl(url: string): string | null {
  if (!url) return null // Optional field
  try {
    new URL(url)
    return null
  } catch {
    return 'Please enter a valid URL'
  }
}

export function validateHexColor(color: string): string | null {
  if (!color) return null
  if (!/^#[0-9A-Fa-f]{6}$/.test(color)) return 'Please enter a valid hex colour (e.g. #1f2937)'
  return null
}
